// ** Third Party Components
import styled from "styled-components";

// ** Custom Components
import Icon from "components/global/Icon";

// ** SVG Static Imports
import { ReactComponent as SolidCheck } from "resources/icons/solid/check.svg";

// #####################################################

export const StyledCheckIcon = styled(Icon).attrs({
	icon: "check",
	svgIconComponent: SolidCheck,
})`
	visibility: hidden;
	vertical-align: inherit;
	font-size: 0.85rem;
	height: 100%;
	svg {
		vertical-align: -0.125em;
	}
`;

// #####################################################
